import { Icon } from "@material-ui/core"
import lon from './logos/lon.png'
                                       
export const Iconl2 = () => (
    <Icon>
        <img src={lon} />
    </Icon>
)